<div class="dashboard-views-table-main"
    infiniteScroll
    [infiniteScrollDistance]="0.05"
    [infiniteScrollThrottle]="250"
    (scrolled)="onScroll()"
>
    <dashboard-views-table-header [hidden]="items.length == 0"></dashboard-views-table-header>
    <ul class="results" [hidden]="sorting">
        <!-- NOTICE: to update order filter by a different property go to pipe to set up new fields in property objects -->
        <li class="result-item" *ngFor="let project of items | projectsSortByField: orderedField" [ngClass]="{opening: (summaryLoadingId == project.id), opened:isSummaryOpen(project) }" >
            <app-projects-summary-item
                [project]="project"
                [transitions]="transitions"
                [exclude]="excludedLabels"
                [badge]="eventBadge(project.id)"
                [updating]="isProjectUpdating(project.id)"
                [opened]="isSummaryOpen(project)"
                (open)="onOpen($event)"
                (openSummary)="onSummaryToggle($event)"
                (actionLabelClick)="onLabelClick($event)"
                (actionStageClick)="onStageClick($event)"
            ></app-projects-summary-item>
            <dashboard-views-table-details-main
                *ngIf="isSummaryOpen(project)"
                [project]="project" >
            </dashboard-views-table-details-main>
            <div class="loader nested" *ngIf="summaryLoadingId == project.id">
                <div class="dimmed">
                    <div class="dimmed_status">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_title"></div>
                    </div>
                    <div class="dimmed_flex">
                        <div class="dimmed_flex_section">
                            <div class="dimmed_avatar"></div>
                            <div class="dimmed_info">
                                <div class="dimmed_title"></div>
                                <div class="dimmed_subtitle"></div>
                            </div>
                        </div>
                        <div class="dimmed_flex_section">
                            <div class="dimmed_avatar"></div>
                            <div class="dimmed_info">
                                <div class="dimmed_title"></div>
                                 <div class="dimmed_subtitle"></div>
                        </div>
                        </div>
                    </div>
                    <div class="dimmed_box"></div>
                </div>
                <!-- <core-helpers-box-loading ></core-helpers-box-loading> -->
            </div>
        </li>
        <li class="loading-more" [hidden]="!loadingMore || resultsStatus == SEARCH_STATUS.FINAL">
            <core-helpers-box-loading ></core-helpers-box-loading>
        </li>
    </ul>
    <div class="loader" [hidden]="!(resultsStatus == SEARCH_STATUS.LOADING && items.length == 0)">
        <div class="dimmed dimmed_list_main">
            <div class="dimmed_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
        </div>
        <!-- 
           <core-helpers-box-loading ></core-helpers-box-loading>  -->
    </div>
    <!-- when filters and no requests -->
    <core-helpers-box-alert-message-icon *ngIf="(items.length == 0 && resultsStatus == SEARCH_STATUS.FINAL && hasSearch)"
        [text]="'There are no matches for your query. Try removing filters or typing a new query.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
    <!-- when no filters and no requests -->
    <core-helpers-box-alert-message-icon [hidden]="!(resultsStatus == SEARCH_STATUS.FINAL && items.length == 0 && !hasSearch)"
        [text]="'There are no projects in this workflow.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
    <core-helpers-box-alert-message-icon 
        *ngIf="status == STATUS_NOT_ALLOWED"
        [text]="'No results found.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
</div>
